import { useCallback, useContext, useEffect, useState } from "react";
import { Button } from "../tailwind/button";
import { CustomerContext } from "../../providers";
import { Heading } from "../tailwind/heading";
import { Text } from "../tailwind/text";
import { EmbeddedGuideflow } from "../EmbeddedGuideflow";
import { Description, Field, Fieldset, Legend } from "../tailwind/fieldset";
import { Input } from "../tailwind/input";
import { api } from "../../api";
import { Link } from "react-router-dom";
import { message } from "antd";

export const NotifyCustomerService = () => {
  const { customer, shop } = useContext(CustomerContext);

  const [gorgiasApiKey, setGorgiasApiKey] = useState("");

  useEffect(() => {
    if (customer.apiKeyGorgias) setGorgiasApiKey(customer.apiKeyGorgias);
  }, [customer]);

  const [emails, setEmails] = useState(
    customer?.emailsForNotifications?.toString() ?? ""
  );
  const handleChangeEmails = useCallback((e) => {
    setEmails(e.target.value);
  }, []);
  const [isLoading, setIsLoading] = useState(false);

  const saveGeneralSettings = async () => {
    setIsLoading(true);

    await api.customer.update(customer.id, {
      emailsForNotifications: emails
        ? emails?.replaceAll(" ", "")?.split(",")
        : null,
    });
    message.success("Email notifications are saved.");

    setIsLoading(false);
  };

  const titleClasses = "font-bold";
  const fieldClasses = "mb-2";

  return (
    <div className="relative">
      <Fieldset>
        <Field className={fieldClasses}>
          <Text className={titleClasses}>Crisp</Text>
          {customer?.crispWebsiteId ? (
            <Text>
              Your account is linked to Crisp (Website ID:{" "}
              {customer.crispWebsiteId})
            </Text>
          ) : (
            <Button
              color="secondaryButton"
              className="mt-1"
              onClick={() =>
                window.open(
                  "https://app.crisp.chat/initiate/plugin/5f0419bc-3ab0-4c89-aa54-ceb55df4ce5e/",
                  "_blank"
                )
              }
            >
              Connect Crisp
            </Button>
          )}
        </Field>
        <Field className={fieldClasses}>
          <Text className={titleClasses}>Gorgias</Text>
          {gorgiasApiKey ? (
            <Input
              name="Gorgias API key"
              value={gorgiasApiKey}
              disabled
              autoComplete="off"
              type="password"
            />
          ) : (
            <Text>You want to connect Simio to Gorgias? Ask our team</Text>
          )}
        </Field>
        <Field className={fieldClasses}>
          <Text className={titleClasses}>Zendesk</Text>
          <Text>You want to connect Simio to Zendesk? Ask our team</Text>
        </Field>

        <Field className={fieldClasses}>
          <Text className={titleClasses}>Email notifications</Text>
          <Text>
            List of emails that will be notified when a new conversation is
            initiated by a customer, separated by commas.
          </Text>
          <Input
            placeholder="hello@gmail.com,contact@gmail.com"
            value={emails}
            onChange={handleChangeEmails}
            autoComplete="off"
            className="mt-1"
          />
        </Field>
        <Button
          color="primaryButton"
          className="mt-2"
          loading={isLoading}
          onClick={saveGeneralSettings}
        >
          Save
        </Button>
      </Fieldset>
    </div>
  );
};
